import type { TBorderRadius, TBorderRadiusSize } from './models';

export const BORDER_RADIUS_SIZES: Record<TBorderRadius, TBorderRadiusSize> = {
    0: 'Default',
    4: 'S',
    8: 'M',
    12: 'L',
    16: 'XL',
    24: '3XL',
} as const;
